import { axiosInstance } from "../axios";

export const dinhMucTonKhoApi = {
  getPaginate: (params) => axiosInstance.get("/stock-thresholds", { params }),
  create: (data) => axiosInstance.post("/stock-thresholds", data),
  getById: (id) => axiosInstance.get(`/stock-thresholds/${id}`),
  update: (id, data) => axiosInstance.put(`/stock-thresholds/${id}`, data),
  remove: (id) => axiosInstance.delete(`/stock-thresholds/${id}`),
  import: (store_code, file) => {
    const formData = new FormData();
    formData.append("file", file);
    return axiosInstance.post(
      `/stock-thresholds/import/${store_code}`,
      formData,
    );
  },
};
